import React, { FC } from 'react'
import { MapPinIcon } from '@/atoms/Icons/MapPinIcon'
import { Text } from '@/atoms/Text'
import { TheaterInfo } from '../types'

interface TheaterCardProps {
  theater: TheaterInfo
}

export const TheaterCard: FC<TheaterCardProps> = ({ theater }) => {
  return (
    <div className="mt-2 rounded-md">
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-core-gray-100">
          <MapPinIcon className="h-5 w-5 text-core-gray-700" />
        </div>
        <div className="flex flex-1 flex-col gap-0.5">
          <Text weight="bold" className="text-sm">
            {theater.name}
          </Text>
          {theater.address && (
            <Text className="text-xs" color="core-gray-600">
              {theater.address}
            </Text>
          )}
          {theater.phone && (
            <Text className="text-xs" color="core-gray-600">
              {formatPhoneNumber(theater.phone)}
            </Text>
          )}
        </div>
      </div>
    </div>
  )
}

const formatPhoneNumber = (phone: string) => {
  return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
}
